import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {Trans} from 'react-i18next';
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";
import connect from "react-redux/es/connect/connect";

class FinishFirstLabelSharingPopup extends Component {

    constructor(props){
        super(props);

        this.closeHandler = this.closeHandler.bind(this);
    }

    closeHandler(){
        this.props.getSharingDetailsPopup([]);
    }

    render() {
	    return (
            <div className="finish-first-label-sharing-popup p-3">
                <h2 className="mt-2"><span role="img" aria-label=":sparkles:">✨</span> {this.props.t("popupFirstShare")} > <span role="img" aria-label=":sparkles:">✨</span></h2>
                <Trans i18nKey="popupFirstShareCollaboratorText" values={{labelName: this.props.selectedContactsGroup.name}}  />

                {/* <p>You have shared your first contact list (<strong>{this.props.selectedContactsGroup.name}</strong>) with <strong>{
                        this.props.selectedContactsGroup.sharingNumber > 0
                        ?
                            this.props.selectedContactsGroup.sharingNumber
                        :
                            '1'
                } collaborator{this.props.selectedContactsGroup.sharingNumber > 1 ? 's' : ''}</strong>!</p> */}

                <p>{this.props.t("popupFirstSharetext1")}</p>
                <ul>
                    <li>{this.props.t("popupFirstShareDragText")}</li>
                    <li><Trans  i18nKey="textShareNewCollaborators" components={{ icon : <svg version="1.1" viewBox="0 0 24 24" width="24" className="mx-2">
                        <path fill="#0297a7" d="M12,0.8c6.2,0,11.3,5,11.3,11.3s-5,11.3-11.3,11.3S0.8,18.2,0.8,12S5.8,0.8,12,0.8 M12,0C5.4,0,0,5.4,0,12
				            s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0L12,0z"/>
                        <line fill="none" stroke="#0297a7" strokeWidth="0.75" strokeMiterlimit="10" x1="8.6" y1="12.8" x2="13.5" y2="15.2"/>
                        <line fill="none" stroke="#0297a7" strokeWidth="0.75" strokeMiterlimit="10" x1="8.6" y1="10.9" x2="13.5" y2="8.5"/>
                        <circle fill="#0297a7" cx="15.4" cy="7.5" r="2.2"/>
                        <circle fill="#0297a7" cx="15.4" cy="16.2" r="2.2"/>
                        <circle fill="#0297a7" cx="6.7" cy="11.9" r="2.2"/>
                       </svg> }} /></li>
                    <li>{this.props.t("renameText")}</li>
                    <li>{this.props.t("createMoreLabelText")}.</li>
                </ul>
	            <div className="text-right">
		            <button type="button" onClick={this.closeHandler} className="btn btn-primary">{this.props.t("okText")}!</button>
	            </div>
            </div>
            
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup : (boolean) => {
            dispatch(getSharingDetailsPopup(boolean))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FinishFirstLabelSharingPopup));